<template>
    <div class="heating-system-warning-2">
        <div class="center">
            <div class="value">{{value}}</div>
            <div class="label">总次数</div>
        </div>
    </div>
</template>

<script>
  import {
    UserStore
  } from '@/utils/Mixin'
  export default {
    mixins: [UserStore],
    data () {
      return {

      }
    },
    computed: {
      value () {
        let value = 0
        if (this.Data && this.Data.data4 && this.Data.data4.num2) {
          value = this.Data.data4.num2
        }
        return value
      }
    }
  }
</script>

<style lang="less">
    .heating-system-warning-2 {
        width: 100%;
        height: 100%;

        .center {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
            width: 180px;
            height: 190px;
            background-image: url("/static/images/home/heating-system-warning/1.png");
            background-size: 100%;
            background-repeat: no-repeat;
            background-position: center;
            .value {
                margin-bottom: 12px;
                height: 36px;
                line-height: 36px;
                font-size: 36px;
                letter-spacing: 2px;
                font-family: WeChatNumber-151125;
                color: #fd4863;
                text-align: center;
            }

            .label {
                height: 16px;
                line-height: 16px;
                font-size: 14px;
                letter-spacing: 1px;
                color: #74a0bf;
                text-align: center;
            }
        }
    }
</style>
